<template>
  <b-modal
    :id="modalId"
    size="lg"
    title="Atualizar Usuário"
    @ok="updateAfiliado"
    @hide="resetForm"
  >
    <validation-observer ref="updateForm">
      <div class="p-2">
        <!-- Header com Avatar e Informações Básicas -->
        <div class="d-flex flex-column align-items-center mr-3">
          <div class="avatar-wrapper mb-2">
            <b-avatar
              :src="formData.foto_perfil"
              size="120px"
              rounded
              class="mb-1"
            />
          </div>
          <div class="d-flex" style="gap: 10px">
            <input
              ref="foto_perfilInput"
              type="file"
              hidden
              accept="image/*"
              @change="handleImageUpload($event)"
            >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              size="sm"
              class="btn-icon"
              :disabled="isUploadingImage"
              @click="$refs.foto_perfilInput.click()"
            >
              <b-spinner v-if="isUploadingImage" small class="mr-50"/>
              <feather-icon v-else icon="PlusIcon" size="14" class="mr-50"/>
              <span>{{ isUploadingImage ? 'Enviando...' : 'Adicionar Foto' }}</span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              size="sm"
              class="btn-icon"
              @click="removeImage"
            >
              <feather-icon icon="Trash2Icon" size="14" class="mr-50"/>
              <span>Remover Foto</span>
            </b-button>
          </div>

          <b-alert
            variant="primary"
            show
            class="mt-2"
            style="font-size: 12px"
          >
            <div class="alert-body">
              <span>
                Para melhor visualização, utilize imagens quadradas com dimensões de <strong>300x300 pixels</strong>.
              </span>
            </div>
          </b-alert>
        </div>
        <h6>Categoria</h6>
        <b-form-group label="Principal" class="mb-3">
          <b-form-select
            v-model="formData.categoria"
            :options="categoriasOptions"
            placeholder="Selecione uma categoria"
          />
        </b-form-group>
        <!-- Redes Sociais -->
        <div class="mb-3">
          <h6>Redes Sociais</h6>
          <div class="d-flex flex-wrap" style="gap: 1rem;">
            <b-form-group
              label="Fonte dos Seguidores"
              class="flex-grow-1"
              style="min-width: 180px;"
            >
              <b-input-group>
                <b-form-select
                  v-model="plataformaSeguidores"
                  :options="plataformasOptions"
                  @change="handlePlataformaSeguidoresChange"
                  :disabled="isFetchingStats"
                />
                <b-form-input
                  :value="formData.seguidores | formatNumber"
                  placeholder="0"
                  readonly
                  class="text-right"
                  style="border-left: 0; background-color: #e9ecef;"
                />
                <template #append v-if="isFetchingStats">
                  <b-spinner small class="m-1"/>
                </template>
              </b-input-group>
            </b-form-group>

            <b-form-group
              label="Instagram"
              class="mr-2 flex-grow-1"
            >
              <b-input-group prepend="@">
                <b-form-input
                  v-model="formData.instagram"
                  placeholder="usuario"
                />
              </b-input-group>
            </b-form-group>

            <b-form-group
              label="YouTube"
              class="mr-2 flex-grow-1"
            >
              <b-form-input
                v-model="formData.youtube"
                placeholder="@usuario"
              />
            </b-form-group>

            <b-form-group
              label="Twitter"
              class="mr-2 flex-grow-1"
            >
              <b-input-group prepend="@">
                <b-form-input
                  v-model="formData.twitter"
                  placeholder="usuario"
                />
              </b-input-group>
            </b-form-group>

            <b-form-group
              label="Tiktok"
              class="mr-2 flex-grow-1"
            >
              <b-form-input
                v-model="formData.tiktok"
                placeholder="usuario"
              />
            </b-form-group>

          </div>
        </div>

        <!-- Tabs -->
        <b-tabs>
          <b-tab title="Biografia" active>
            <b-form-group label="Sobre">
              <b-form-textarea
                v-model="formData.biografia"
                rows="4"
                placeholder="Descreva sua experiência e especialidades..."
              />
            </b-form-group>

            <b-form-group label="Especialidades">
              <b-form-tags
                v-model="formData.especialidades"
                placeholder="Adicione uma especialidade"
                class="mb-2"
              />
            </b-form-group>
          </b-tab>

          <!-- <b-tab title="Contato">
            <b-form-group label="Email">
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  v-model="formData.email"
                  type="email"
                  placeholder="email@exemplo.com"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="Telefone">
              <validation-provider
                #default="{ errors }"
                name="Telefone"
                rules="required"
              >
                <b-form-input
                  v-model="formData.telefone"
                  v-mask="'(##) #####-####'"
                  placeholder="(00) 00000-0000"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-tab> -->
        </b-tabs>
      </div>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal,
  BAvatar,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BFormTags,
  BTabs,
  BAlert,
  BTab,
  BInputGroup,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { mask } from 'vue-the-mask'
import axios from '@axios'
import axiosAWS from '@/libs/axiosAWS'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'UserUpdateModal',
  components: {
    BModal,
    BAvatar,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BFormTags,
    BTabs,
    BTab,
    BAlert,
    BButton,
    BSpinner,
    BInputGroup,
    ValidationObserver,
  },

  directives: {
    mask,
    Ripple,
  },

  filters: { // Adiciona um filtro para formatar números grandes
    formatNumber(value) {
      if (isNaN(value) || value === null) return '0'
      return Number(value).toLocaleString('pt-BR')
    }
  },

  props: {
    modalId: {
      type: String,
      default: 'user-update-modal',
    },
    userData: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    const maxSizeEnv = Number(process.env.VUE_APP_IMAGE_MAX_SIZE_MB)
    const maxImageSizeMb = Number.isFinite(maxSizeEnv) && maxSizeEnv > 0 ? maxSizeEnv : 5

    return {
      defaultAvatar: 'default-avatar-url.png',
      maxImageSizeMb,
      maxImageSize: maxImageSizeMb * 1024 * 1024,
      maxImageDimension: 1920,
      compressionQuality: 0.92,
      allowedImageTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
      plataformaSeguidores: 'instagram',
      plataformasOptions: [
        { value: 'instagram', text: 'Instagram' },
        { value: 'youtube', text: 'YouTube' },
        { value: 'x', text: 'Twitter (X)' },
        { value: 'tiktok', text: 'TikTok' },
      ],
      isSaving: false,
      isFetchingStats: false,
      isUploadingImage: false,
      imageUploadData: {
        foto_perfil_url: '',
        foto_perfil_key: '',
      },
      formData: {
        foto_perfil: '',
        nome: '',
        username: '',
        categoria: null,
        instagram: '',
        seguidores: 0,
        youtube: '',
        twitter: '',
        tiktok: '',
        biografia: '',
        especialidades: [],
        // email: '',
        // telefone: '',
      },
      categoriasOptions: [],
    }
  },

  watch: {
    userData: {
      handler(newValue) {
        if (newValue) {
          this.formData = { ...this.formData, ...newValue }
        }
      },
      immediate: true,
    },
    modalId: {
      immediate: true,
      handler(newVal) {
        if (newVal && (this.userData?.afiliado?.id || this.userData?.vendedor?.id)) {
          this.fetchAfiliadoData()
        }
      },
    },
    selectedFile(file) {
      if (file) {
        this.handleImageUpload(file)
      }
    },
  },
  mounted() {
    this.fetchCategorias() // Carrega as categorias ao montar o componente
  },

  methods: {
    showFileWarning(title, text, variant = 'warning') {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          text,
          icon: 'AlertTriangleIcon',
          variant,
        },
      })
    },
    validateImageType(file) {
      if (!this.allowedImageTypes.includes(file.type)) {
        this.showFileWarning(
          'Tipo de arquivo inválido',
          'Por favor, selecione uma imagem (JPEG, PNG ou GIF).',
        )
        return false
      }

      return true
    },
    loadImage(file) {
      return new Promise((resolve, reject) => {
        const image = new Image()
        const objectUrl = URL.createObjectURL(file)

        image.onload = () => {
          URL.revokeObjectURL(objectUrl)
          resolve(image)
        }

        image.onerror = () => {
          URL.revokeObjectURL(objectUrl)
          reject(new Error('Não foi possível ler a imagem selecionada.'))
        }

        image.src = objectUrl
      })
    },
    canvasToFile(canvas, file, mimeType, quality) {
      return new Promise(resolve => {
        canvas.toBlob(blob => {
          if (!blob) {
            resolve(file)
            return
          }

          resolve(new File([blob], file.name, {
            type: mimeType,
            lastModified: file.lastModified,
          }))
        }, mimeType, quality)
      })
    },
    hasTransparency(context, width, height) {
      const { data } = context.getImageData(0, 0, width, height)

      for (let i = 3; i < data.length; i += 4) {
        if (data[i] < 255) {
          return true
        }
      }

      return false
    },
    async compressImage(file) {
      if (file.type === 'image/gif') {
        return file
      }

      const image = await this.loadImage(file)
      const needsResize = image.width > this.maxImageDimension || image.height > this.maxImageDimension
      const needsCompress = file.size > this.maxImageSize

      if (!needsResize && !needsCompress) {
        return file
      }

      const scale = Math.min(
        this.maxImageDimension / image.width,
        this.maxImageDimension / image.height,
        1,
      )
      const width = Math.max(1, Math.round(image.width * scale))
      const height = Math.max(1, Math.round(image.height * scale))
      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height

      const context = canvas.getContext('2d')
      context.drawImage(image, 0, 0, width, height)

      const isPng = file.type === 'image/png'
      const mimeType = isPng && this.hasTransparency(context, width, height)
        ? 'image/png'
        : 'image/jpeg'
      const quality = mimeType === 'image/jpeg' ? this.compressionQuality : undefined

      const compressedFile = await this.canvasToFile(canvas, file, mimeType, quality)

      if (compressedFile.size >= file.size) {
        return file
      }

      return compressedFile
    },
    async prepareImage(file) {
      if (!this.validateImageType(file)) {
        return null
      }

      const compressedFile = await this.compressImage(file)

      if (compressedFile.size > this.maxImageSize) {
        this.showFileWarning(
          'Arquivo muito grande',
          `A imagem ainda ficou acima de ${this.maxImageSizeMb}MB após a compressão automática. Reduza a resolução ou envie uma versão menor.`,
        )
        return null
      }

      return compressedFile
    },
    readFileAsDataURL(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = e => resolve(e.target.result)
        reader.onerror = () => reject(new Error('Não foi possível processar a imagem selecionada.'))
        reader.readAsDataURL(file)
      })
    },
    async fetchCategorias() {
      try {
        const { data } = await axios.get('/categorias')
        // Acessa o array de categorias dentro de data.categories
        if (Array.isArray(data.categories)) {
          this.categoriasOptions = data.categories.map(categoria => ({
            value: categoria.id,
            text: categoria.nome,
          }))
        } else {
          throw new Error('Formato inesperado da resposta da API')
        }
      } catch (error) {
        console.log('Erro ao buscar categorias:', error)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao carregar categorias',
            text: 'Não foi possível carregar as categorias',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        console.error('Erro ao buscar categorias:', error)
      }
    },
    async fetchAfiliadoData() {
      try {
        let data

        if (this.userData.afiliado?.id) {
          // Caso seja um afiliado
          const response = await axios.get(`/afiliado/${this.userData.afiliado.id}`)
          data = response.data
        } else if (this.userData.vendedor?.id) {
          // Caso seja um vendedor
          const response = await axios.get(`/vendedor/${this.userData.vendedor.id}`)
          data = response.data
        } else {
          throw new Error('Nenhum ID válido encontrado para afiliado ou vendedor.')
        }

        // Atualiza o formData com os dados recebidos
        this.formData = {
          ...this.formData,
          foto_perfil: data.usuario.foto_perfil || this.defaultAvatar,
          nome: data.nome,
          username: data.username,
          instagram: data.instagram,
          seguidores: data.seguidores || 0,
          youtube: data.youtube,
          twitter: data.twitter,
          tiktok: data.tiktok,
          biografia: data.biografia,
          especialidades: data.especialidades || [],
          categoria: data.categoria?.id || null,
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao carregar dados',
            text: 'Não foi possível carregar os dados do perfil',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
        console.error('Erro ao buscar dados:', error);
      }
    },

    async updateAfiliado() {
      try {
        // Usar a URL da imagem do AWS se disponível, senão usar a foto atual
        const fotoPerfilUrl = this.imageUploadData.foto_perfil_url || this.formData.foto_perfil

        const formDataToSend = {
          // Dados básicos
          nome: this.formData.nome,
          username: this.formData.username,
          foto_perfil: fotoPerfilUrl,
          // Redes sociais
          instagram: this.formData.instagram,
          seguidores: this.formData.seguidores,
          youtube: this.formData.youtube,
          twitter: this.formData.twitter,
          tiktok: this.formData.tiktok,
          // Biografia e especialidades
          biografia: this.formData.biografia,
          especialidades: this.formData.especialidades,
          id_categoria: this.formData.categoria,
        }

        let response

        if (this.userData.afiliado?.id) {
          // Caso seja um afiliado
          response = await axios.put(`/afiliado/${this.userData.afiliado.id}`, formDataToSend)
        } else if (this.userData.vendedor?.id) {
          // Caso seja um vendedor
          response = await axios.put(`/vendedor/${this.userData.vendedor.id}`, formDataToSend)
        } else {
          throw new Error('Nenhum ID válido encontrado para afiliado ou vendedor.')
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Perfil atualizado com sucesso!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })

        // Atualiza os dados no localStorage
        const userData = JSON.parse(localStorage.getItem('userData'))
        localStorage.setItem(
          'userData',
          JSON.stringify({
            ...userData,
            ...formDataToSend,
          }),
        )

        // Limpa os dados temporários da imagem após sucesso
        if (this.imageUploadData.foto_perfil_url) {
          this.imageUploadData.foto_perfil_url = ''
          this.imageUploadData.foto_perfil_key = ''
        }

        return response.data
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao atualizar perfil',
            text: error.response?.data?.message || 'Ocorreu um erro ao atualizar os dados',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        throw error
      }
    },

    async handleImageUpload(e) {
      const file = e.target.files[0]
      if (!file) return

      const preparedFile = await this.prepareImage(file)
      if (!preparedFile) return

      // Exibir preview da imagem enquanto faz upload
      const preview = await this.readFileAsDataURL(preparedFile)
      this.formData.foto_perfil = preview
      // Fazer upload para AWS em background
      this.uploadImageToAWS(preparedFile)
    },

    async uploadImageToAWS(file) {
      this.isUploadingImage = true
      try {
        const userData = JSON.parse(localStorage.getItem('userData'))
        const formData = new FormData()
        formData.append('image', file)
        formData.append(
          'caminho',
          `${userData.uuid}_${userData.id}/perfil_imagens/foto_perfil_${userData.uuid}`,
        )

        const response = await axiosAWS.post('/upload', formData)
        // Armazenar dados da imagem no AWS
        this.imageUploadData.foto_perfil_url = response.data.image_url
        this.imageUploadData.foto_perfil_key = response.data.key

        // Atualizar foto_perfil do usuário na base de dados
        try {
          await axios.put(`/users/${userData.id}`, {
            foto_perfil: response.data.image_url,
          })

          // Atualizar dados no localStorage
          const updatedUserData = { ...userData, foto_perfil: response.data.image_url }
          localStorage.setItem('userData', JSON.stringify(updatedUserData))

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Foto de perfil atualizada!',
              text: 'A imagem foi carregada e salva com sucesso',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
        } catch (updateError) {
          console.error('Erro ao atualizar foto do usuário:', updateError)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Imagem carregada, mas houve erro ao salvar',
              text: 'A imagem foi enviada, mas não foi possível atualizar o perfil',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          })
        }
      } catch (error) {
        console.error('Erro ao fazer upload da imagem:', error)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao carregar imagem',
            text: 'Não foi possível enviar a imagem. Tente novamente.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        // Restaurar avatar padrão em caso de erro
        this.formData.foto_perfil = this.defaultAvatar
      } finally {
        this.isUploadingImage = false
      }
    },

    async removeImage() {
      // Se existe uma imagem no AWS, remove ela
      if (this.imageUploadData.foto_perfil_key) {
        try {
          await axiosAWS.delete('/delete', {
            data: {
              file_key: this.imageUploadData.foto_perfil_key,
            },
          })
          // Limpa os dados da imagem AWS
          this.imageUploadData.foto_perfil_url = ''
          this.imageUploadData.foto_perfil_key = ''
        } catch (error) {
          console.error('Erro ao remover imagem do AWS:', error)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao remover imagem',
              text: 'Não foi possível remover a imagem do servidor',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          })
        }
      }

      // Remove a imagem do preview
      this.formData.foto_perfil = this.defaultAvatar
      // Limpa o input de arquivo
      if (this.$refs.foto_perfilInput) {
        this.$refs.foto_perfilInput.value = ''
      }
    },

    async updateUser() {
      // Implemente a chamada API aqui
      await axios.put(`/api/users/${this.userData.id}`, this.formData)
    },

    getProfileURL(platform, username) {
      const cleanUser = username.replace(/^@/, '') // removes @ do começo
      switch (platform.toLowerCase()) {
        case 'instagram':
          return `https://www.instagram.com/${cleanUser}/`
        case 'youtube':
          // A API parece focada em Instagram, mas mantendo a lógica
          // Verifique se a API externa realmente suporta YouTube com este formato
          return `https://www.youtube.com/@${cleanUser}`
        case 'x': // Twitter
          return `https://twitter.com/${cleanUser}`
        case 'tiktok':
          return `https://www.tiktok.com/@${cleanUser}`
        case 'facebook':
          // Verifique se a API externa realmente suporta Facebook
          return `https://www.facebook.com/${cleanUser}`
        default:
          console.warn(`Plataforma '${platform}' pode não ser suportada pela API externa.`)
          return null // Retorna null se não suportado
      }
    },

    handlePlataformaSeguidoresChange(novaPlataforma) {
      const formDataKey = novaPlataforma === 'x' ? 'twitter' : novaPlataforma

      const username = this.formData[formDataKey] // Pega o username da plataforma selecionada
      // console.log(`Plataforma selecionada: ${novaPlataforma}, Username: ${username}`);
      if (username) {
        this.fetchSocialStats(novaPlataforma, username)
      } else {
        // Se não houver username para a plataforma selecionada, limpa os seguidores
        this.formData.seguidores = 0
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `Informe o @usuário do ${this.plataformasOptions.find(p => p.value === novaPlataforma)?.text || novaPlataforma}`,
            icon: 'InfoIcon',
            variant: 'info',
          },
        })
      }
    },

    async fetchSocialStats(platform, username) {
      if (!username || this.isFetchingStats) {
        return;
      }

      const cleanUsername = username.replace(/^@/, '')
      if (!cleanUsername) return;

      // Construir a URL do perfil usando o helper
      const profileURL = this.getProfileURL(platform, cleanUsername)
      if (!profileURL) {
        console.warn(`Não foi possível gerar URL para ${platform}`)
        return // Sai se a plataforma não for suportada pelo helper
      }

      this.isFetchingStats = true;
      try {
        // --- CHAMADA DIRETA PARA RAPIDAPI ---
        const encodedURL = encodeURIComponent(profileURL)
        const rapidApiUrl = `https://instagram-statistics-api.p.rapidapi.com/community`
        const apiKey = '6a347a17cfmsh3b0401c1b94844ap1ef796jsnceee01ae3979' // SUA CHAVE AQUI - NÃO RECOMENDADO NO FRONTEND
        const apiHost = 'instagram-statistics-api.p.rapidapi.com'

        const response = await axios.get(rapidApiUrl, {
          params: {
            url: profileURL,
          },
          headers: {
            'x-rapidapi-key': apiKey,
            'x-rapidapi-host': apiHost,
          },
        })
        // --- FIM DA CHAMADA DIRETA ---

        // A estrutura da resposta da RapidAPI pode ser diferente
        // Ajuste conforme a documentação da API: response.data?.data?.usersCount
        const data = response.data?.data // Acessa o objeto 'data' dentro da resposta
        const followers = data?.usersCount

        if (typeof followers !== 'undefined') {
          // Atualiza o número de seguidores, principalmente se for Instagram
          if (followers > 0 || !this.formData.seguidores) {
            this.formData.seguidores = followers
          }
        } else {
          console.warn(`Não foi possível obter seguidores para ${platform}: ${cleanUsername}. Resposta da API:`, response.data)
        }

      } catch (error) {
        console.error(`Erro ao buscar dados para ${platform} via RapidAPI:`, error)
        // O erro pode ser mais detalhado vindo da RapidAPI
        const errorMsg = error.response?.data?.message || error.response?.data?.error || 'Não foi possível verificar os dados da rede social via API externa.'
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `Erro ao buscar dados do ${platform}`,
            text: errorMsg,
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
      } finally {
        this.isFetchingStats = false
      }
    },

    resetForm() {
      this.$refs.updateForm.reset()
      // Limpa dados temporários da imagem AWS
      this.imageUploadData.foto_perfil_url = ''
      this.imageUploadData.foto_perfil_key = ''
      this.isUploadingImage = false

      if (this.userData?.afiliado?.id) {
        this.fetchAfiliadoData() // Recarrega os dados originais para afiliado
      } else if (this.userData?.vendedor?.id) {
        this.fetchAfiliadoData() // Recarrega os dados originais para vendedor
      } else {
        // Mantém os dados atuais se não for afiliado ou vendedor
        this.formData = {
          ...this.formData,
          foto_perfil: this.formData.foto_perfil || this.defaultAvatar,
          nome: this.formData.nome,
          username: this.formData.username,
          categoria: this.formData.categoria,
          instagram: this.formData.instagram,
          seguidores: this.formData.seguidores,
          youtube: this.formData.youtube,
          twitter: this.formData.twitter,
          tiktok: this.formData.tiktok,
          biografia: this.formData.biografia,
          especialidades: this.formData.especialidades,
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-profile {
  .modal-body {
    padding: 0;
  }
}

.profile-avatar {
  width: 120px;
  height: 120px;
  object-fit: cover;
}

.tab-content {
  padding: 1rem 0;
}

.badge {
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
}
.avatar-wrapper {
  width: 120px;
  height: 120px;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 140px;
  padding: 0.6rem 1rem;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.25s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
  }

  .feather {
    margin-right: 0.5rem;
    stroke-width: 2.5px;
    transition: transform 0.2s ease;
  }

  &:hover .feather {
    transform: scale(1.1);
  }

  span {
    font-size: 0.875rem;
    letter-spacing: 0.3px;
  }
}

.alert {
  max-width: 300px;
  margin-top: 1rem;
}

.input-group-append {
  .input-group-text {
    background-color: #f8f8f8;
    color: #6e6b7b;
    font-size: 0.875rem;
  }
}

input[type="number"] {
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    opacity: 1;
    height: 24px;
  }
}
</style>
